import React from 'react';
import { Box } from '@mui/material';
import { useOutletContext, useNavigate } from 'react-router-dom';

import MeterHeader from '../../components/Meter/MeterHeader';
import MeterFilters from '../../components/Meter/MeterFilters';
import MeterTable from '../../components/Meter/MeterTable';
import CenteredLoader from '../../../../components/loaders/PageLoader';
import styles from './Meter.styles';

import { useMeters } from '../../hooks/useMeters';
import { useMeterFilters } from '../../hooks/useMeterFilters';
import { mapMetersToRows } from '../../utils/meter.helpers';
import { useCrumb } from '../../../../layouts/TrailProvider';

export default function Meter() {
  const { isSidebarExpanded } = useOutletContext();
  const navigate = useNavigate();

  useCrumb('Meters', '/home/meters');

  const { data, loading } = useMeters();
  const rows = mapMetersToRows(data);

  const {
    searchQuery, setSearchQuery,
    dateRange, setDateRange,
    filters, setFilters,
    filteredRows,
  } = useMeterFilters(rows);

  return (
    <Box
      sx={{
        ...styles.meterContent,
        marginLeft: isSidebarExpanded ? '240px' : '95px',
        width: isSidebarExpanded ? 'calc(100vw - 240px)' : 'calc(100vw - 95px)',
        transition: 'all 0.3s ease',
      }}
    >
      {loading ? (
        <CenteredLoader />
      ) : (
        <>
          <MeterHeader
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            onSearch={() => {}}
          />

          <MeterFilters
            filters={filters}
            setFilters={setFilters}
            dateRange={dateRange}
            setDateRange={setDateRange}
            meterNumberOptions={[...new Set(rows.map(r => r.meterNumber))]}
            unitOptions={[...new Set(rows.map(r => r.unit))]}
            evnOptions={[...new Set(rows.map(r => r.evn))]}
            meterTypeOptions={[...new Set(rows.map(r => r.meterType))]}
            onAdd={() => navigate('/home/create-config')}
          />

          <MeterTable rows={filteredRows} actionsEnabled />
        </>
      )}
    </Box>
  );
}
